export type TokenWithUnit = { unit: string; value: number };

export const isTokenWithUnit = (value: unknown): value is TokenWithUnit =>
  typeof value === 'object' &&
  value !== null &&
  'unit' in value &&
  'value' in value &&
  typeof value.value === 'number' &&
  typeof value.unit === 'string';
